module.exports = __webpack_public_path__ + "img/1.3c691b32.jpg";